import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import "./features/utils/i18n-react.ts";
import "./sentry.config";

createRoot(document.getElementById("root")!).render(<App />);
